import {
  HEADLINE_ORIENTATION,
} from "../../../constants/props";
import { SERVICES_CONTENT } from "../../../constants/content/pages/services";

import Headline from "../../../components/headline/headline";
import TeaserTeam from "../../../components/teaser-team/teaser-team";
import ServiceProcess from "../../../components/service-process/service-process";
import Service from "../../../components/service/service";

import "./styles.scss";
import CustomRow from "../../../shared/costum-row/costum-row";
import { Col } from "antd";

const Services = () => {
  return (
    <div className="Services-page">
      <div className="Services-padding">
        <Headline
          title={SERVICES_CONTENT.headline.title}
          subtitle={SERVICES_CONTENT.headline.subtitle}
          orientation={HEADLINE_ORIENTATION.BOTTOM}
        />
      </div>

      <div className="Services-container Services-padding">
        {SERVICES_CONTENT.services.map((service, index) => (
          <Service
            key={index}
            title={service.title}
            description={service.description}
          />
        ))}
      </div>

      <div className="Services-service-process Services-padding">
        <TeaserTeam />
        <Headline
          title={SERVICES_CONTENT.processHeadline.title}
          subtitle={SERVICES_CONTENT.processHeadline.subtitle}
          orientation={HEADLINE_ORIENTATION.TOP}
        />
        <CustomRow>
          {SERVICES_CONTENT.processSteps.map((step, index) => (
            <Col key={index} span={24}>
              <CustomRow justify={step.direction === "left" ? "start" : "end"}>
                <Col xxl={8} xl={8} lg={9} md={11} sm={24}>
                  <ServiceProcess
                    number={step.number}
                    title={step.title}
                    description={step.description}
                    direction={step.direction}
                  />
                </Col>
              </CustomRow>
            </Col>
          ))}
        </CustomRow>
      </div>
    </div>
  );
};

export default Services;
